import { exampleTenant } from "../tenants/example/config";
import { sailplotTenant } from "../tenants/sailplot/config";
import { runtimeCustomerTenant } from "./customerTenant";
import type { PlatformTenant } from "./types";
import { validateTenantRegistry } from "./validateTenantRegistry";

const runtimeTenant = runtimeCustomerTenant();

export const tenantRegistry: readonly PlatformTenant[] = validateTenantRegistry(
  [sailplotTenant, exampleTenant, ...(runtimeTenant ? [runtimeTenant] : [])],
);

export const tenantById = new Map(
  tenantRegistry.map((tenant) => [tenant.id, tenant]),
);

export const tenantByDomain = new Map(
  tenantRegistry.flatMap((tenant) =>
    tenant.domains.map(
      (domain) =>
        [domain.trim().toLowerCase().replace(/\.$/u, ""), tenant] as const,
    ),
  ),
);
